export const COLUNAS_CONTRATOS_ALECE = [
    "Código",
    "Código na instituição",
    "Modalidade",
    "Data",
    "Consignatário",
    "Verba",
    "Matrícula",
    "CPF",
    "Folha",
    "Nome",
    "Período",
    "Prazo Total",
    "Prazo Restante",
    "Valor da Parcela",
    "Total Parcelas",
    "Valor liberado",
    "Situação do contrato",
    "Carência / Primeiro Lançamento",
    "Previsão de Termino",
    "Natureza",
];
//# sourceMappingURL=alece-carga-colunas.js.map